'use client';

import type { ReactNode } from 'react';

import { ChevronLeft } from '@gds/Icons/Paths/ChevronLeft';
import { ChevronRight } from '@gds/Icons/Paths/ChevronRight';
import { useModal } from '@modal/Hooks/UseModal';

import styles from './MobileViewContainer.module.css';

export const MobileViewContainer = ({
  title,
  content,
  titleIcon,
  className = '',
}: {
  title: string;
  content: ReactNode;
  titleIcon: ReactNode;
  className?: string;
}) => {
  const { openModal } = useModal();

  const handleClick = () => {
    openModal(content, {
      header: title,
      headerClassName: styles.modalHeader,
      modalBodyClassName: styles.modalBody,
      customCloseIcon: <ChevronLeft />,
      customScrollClassName: 'noScrollAccordion',
      screenWrapperClassName: styles.modalHeight,
    });
  };

  return (
    <div className={`${className} ${styles.mobileViewContainer}`} onClick={() => handleClick()}>
      <span className={styles.titleWithIcon}>
        {titleIcon}
        {title}
      </span>
      <ChevronRight />
    </div>
  );
};
